<template>
  <div id="app" class="wrapper" style="padding-right: 2px; padding-left: 2px">
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <div class="app">
        <br />

        <h3 class="title cor-preta">Produto selecionado:</h3>

        <div>
          <table class="table">
            <thead>
              <tr>
                <th scope="col">
                  <label class="cor-preta"><b>Produto</b></label>
                </th>
                <th scope="col">
                  <label class="cor-preta"><b>Preço</b></label>
                </th>
              </tr>
            </thead>
            <tbody id="listarproduto()">
              <tr>
                <td>
                  <label class="cor-preta"
                    ><b>{{ product.nm }}</b></label
                  >
                </td>
                <td>
                  <label class="cor-preta"
                    ><b>
                    <span v-if="product.vl_promo > 0"> R$ {{ product.vl_promo }}</span>
                    <span v-else> R$ {{ product.vl }}</span>
                    </b></label
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <b>Alguma observação ?</b>
          <textarea
            class="form-control"
            v-model="obs"
            id="obs"
            name="obs"
            rows="2"
            placeholder="Ex: Digite as observações aqui..."
          ></textarea>
        </div>

        <div class="modal-footer">
          <button
            style="background-color: #006400"
            @click="addItem(product, adicionaispergunta, obs)"
            type="button"
            class="btn btn-dark"
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
    <br />
    <footer class="main-footer" align="center">
      <b class="cor-preta">Todos os direitos reservados.</b><br />
      <b class="cor-preta"
        >&copy; 2022
        <a target="”_blank”" href="https://www.panterafood.com.br"
          >Pantera Food</a
        >.</b
      ><br />
      <img
        width="100"
        src="https://apppanterafood.com.br/DeliveryCenter/3/logo/pantera.svg"
      />
    </footer>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Inis from "../services/inis";
import Swal from "sweetalert2";
import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: "aes" });

export default {
  name: "ProdutoUnico",
  data() {
    return {
      adicionaispergunta: [],
      product: [],
      product: {
        cd: "",
        nm: "",
        classe: "",
        ingredientes: "",
        vl: "",
        vl_promo: "",
      },
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      obs: "",
    };
  },
  computed: {
    ...mapGetters({
      length: "getNumberOfProducts",
    }),
  },
  methods: {
    listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis = resposta.data;
      });
    },
    listarproduto() {
      this.product = ls.get("product" + process.env.VUE_APP_CONTRATO);
    },
    addItem(product, adicionaispergunta, obs) {
      var d1 = this.$store.state.date_token;
      var d2 = moment().format("YYYY-MM-DD hh:mm:ss");
      var diff = moment(d2, "YYYY-MM-DD HH:mm:ss").diff(
        moment(d1, "YYYY-MM-DD HH:mm:ss")
      );
      diff = diff / 60000;

      if (this.$store.state.funcionamento === "0") {
        Swal.fire({
          title: "Estabelecimento fechado",
          confirmButtonColor: "#000000",
        });
        //alert("Estabelecimento Fechado");
      } else if (diff > 30) {
        Swal.fire({
          title: "Tempo de conexão expirou! Leia o QRcode novamente!",
          confirmButtonColor: "#000000",
        });
      } else if (this.$store.state.funcionamento === "1") {
        if (obs != "") {
          adicionaispergunta[0] = {
            nm: obs,
            qtd: 1,
            vl: 0,
          };
        }

        this.$store.dispatch("addToCart", {
          product,
          adicionaispergunta,
        });
        this.$router.push("/cart");
        //adicionaispergunta
        //addToCart({ product, adicionaispergunta });
      }
    },

    ...mapActions(["addToCart"]),
  },
  mounted() {
    this.listarproduto(), this.listarinis();
  },
};
</script>
